import { Request } from '../../../../httpClient/serverApi/requests/Request';

export interface IRunActiveDirectoryGroupsSyncParams {
}

export interface IRunActiveDirectoryGroupsSyncResult {
}

export class RunActiveDirectoryGroupsSyncRequest extends Request<IRunActiveDirectoryGroupsSyncParams, IRunActiveDirectoryGroupsSyncResult> {
  constructor(params: IRunActiveDirectoryGroupsSyncParams = {}) {
    super('runActiveDirectoryGroupsSyncTask', params);
  }
}
